export default __webpack_public_path__ + "static/media/label2.c51c6180.svg";